import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { DBExport, DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (exportType: string) => {
  if (!exportType) {
    throw new Error('`exportType` is required');
  }
};

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'> & {
  exportType: DBExportType;
};

type Response = DBExport[];

export const getExports = async (
  scope: RequestScope,
  { exportType, limit = 1000, page = 1 }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(exportType);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(
      `${exportType}/export?sort=created_at:-1&limit=${limit}&page=${page}`,
      options
    );

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
